import { defineStore, acceptHMRUpdate } from "pinia";
import { brogglBack } from "../axios.js";
import router from "../router/index.js";
import { useProductStore } from "./product.js";
import { useClientStore } from "./client.js";
import { Colors } from "chart.js";

export const useEntriesStore = defineStore("entries", {
  state: () => ({
    entries: {},
    currentPage: 1,
    //nextPage: 1,
    barChartData: {
      labels: [],
      datasets: [
        {
          label: "Monthly Support",
          backgroundColor: [
            "#1880e7",
            "#2ec0e7",
            "#130df4",
            "#0ec6fe",
            "#0e47fe",
            "#2ec0e7",
          ],
          fill: false,
          data: [],
        },
      ],
    },
    chartData: {
      labels: [],
      datasets: [
        {
          label: "Monthly Support",
          backgroundColor: "#1880e7",
          borderColor: "#1880e7",
          borderWidth: "2",
          fill: false,
          data: [],
          pointBackgroundColor: "#ffffff",
        },
      ],
    },
    loaded: false,
    basicSupportHours: 0,
    basicSupportAverage: 0,
    basicTechnicalSupportHoursMonthly: 0,
    basicTechnicalSupportHoursSinceContract: 0,
    timeCounterByEntity: [],
    customerSuccesHours: 0,
    customerSuccessAverage: 0,
    askTSEHoursSinceContract: 0,
    askTSEHoursMonthly: 0,
    askTSEHoursMeanMonthly: 0,
    professionalServicesHours: 0,
    professionalServicesAverage: 0,
    onboardingHours: 0,
    onboardingAverage: 0,
    totalProducts: 0,
    totalUsageProducts: 0,
    totalTimeSpentOnCampaigns: 0,
    averageTimeSpentOnCampaigns: 0,
    entities: [],
    entriesLoaded: false,
    offeredCampaigns: [],
    offeredCampaignsErrorMsg: "",
    offeredAnalysis: [],
    offeredAnalysisErrorMsg: "",
    totalItems: 0,
    testIdToSearch: "",
  }),
  getters: {
    getEntries: (state) => {
      return state.entries;
    },
    getCurrentPage: (state) => {
      return state.currentPage;
    },
    getNextPage: (state) => {
      return state.nextPage;
    },
    getBarChartData: (state) => {
      return state.barChartData;
    },
    getChartData: (state) => {
      return state.chartData;
    },
    getLoaded: (state) => {
      return state.loaded;
    },
    getBasicSupportHours: (state) => {
      return state.basicSupportHours;
    },
    getBasicSupportAverage: (state) => {
      return state.basicSupportAverage;
    },
    getBasicTechnicalSupportHoursMonthly: (state) => {
      return state.basicTechnicalSupportHoursMonthly;
    },
    getBasicTechnicalSupportHoursSinceContract: (state) => {
      return state.basicTechnicalSupportHoursSinceContract;
    },
    getTimeCounterByEntity: (state) => {
      return state.timeCounterByEntity;
    },
    getCustomerSuccesHours: (state) => {
      return state.customerSuccesHours;
    },
    getCustomerSuccessAverage: (state) => {
      return state.customerSuccessAverage;
    },
    getEntities: (state) => {
      return state.entities;
    },
    getEntriesLoaded: (state) => {
      return state.entriesLoaded;
    },
    getAskTSEHoursSinceContract: (state) => {
      return state.askTSEHoursSinceContract;
    },
    getAskTSEHoursMonthly: (state) => {
      return state.askTSEHoursMonthly;
    },
    getAskTSEHoursMeanMonthly: (state) => {
      return state.askTSEHoursMeanMonthly;
    },
    getOfferedCampaigns: (state) => {
      return state.offeredCampaigns;
    },
    getOfferedCampaignsErrorMsg: (state) => {
      return state.offeredCampaignsErrorMsg;
    },
    getOfferedAnalysis: (state) => {
      return state.offeredAnalysis;
    },
    getOfferedAnalysisErrorMsg: (state) => {
      return state.offeredAnalysisErrorMsg;
    },
    getTotalItems: (state) => {
      return state.totalItems;
    },
    getProfessionalServicesHours: (state) => {
      return state.professionalServicesHours;
    },
    getProfessionalServicesAverage: (state) => {
      return state.professionalServicesAverage;
    },
    getOnboardingHours: (state) => {
      return state.onboardingHours;
    },
    getOnboardingAverage: (state) => {
      return state.onboardingAverage;
    },
    getTotalProducts: (state) => {
      return state.totalProducts;
    },
    getTotalUsageProducts: (state) => {
      return state.totalUsageProducts;
    },
    getTotalTimeSpentOnCampaigns: (state) => {
      return state.totalTimeSpentOnCampaigns;
    },
    getAverageTimeSpentOnCampaigns: (state) => {
      return state.averageTimeSpentOnCampaigns;
    },
    getTestIdToSearch: (state) => {
      return state.testIdToSearch;
    },
  },
  actions: {
    async fetchEntries() {
      const clientStore = useClientStore();
      let clientId = clientStore.getClientId();
      let oppId = clientStore.getCurrSfOppId();
      try {
        this.fetchEntriesV2(clientId, oppId);
      } catch (err) {
        console.log(err);
      }
    },
    async fetchEntriesV2(clientId, oppId) {
      this.entriesLoaded = false;
      this.entries = {};
      try {
        let currParams = {}
        if (this.testIdToSearch !== "") {
          currParams = {page: this.currentPage, testId: this.testIdToSearch}
        } else {
          currParams = {page: this.currentPage}
        }
        let res = await brogglBack.get("/entries/" + oppId, {
          params: currParams,
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        if (this.testIdToSearch !== "") {
          let entriesBack = res.data.data.entries;
          let sortedResult = {};
          const sortedKeys = Object.keys(entriesBack).sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return dateB - dateA;
          });
          sortedKeys.forEach((key) => {
            sortedResult[key] = entriesBack[key];
          });
          this.entries = sortedResult;
          this.totalItems = res.data.data.nbrOfEntries;
        } else {
          const sortedKeys = Object.keys(res.data.data).sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return dateB - dateA;
          });

          const sortedResult = {};
          sortedKeys.forEach((key) => {
            sortedResult[key] = res.data.data[key];
          });
          this.entries = sortedResult;
          let resTotalEntries = await brogglBack.get(
            "/entries/number-of-entries-client/" + clientId + "/" + oppId,
            {
              headers: {
                Authorization: "Bearer " + window.$cookies.get("jwt"),
              },
            },
          );
          this.totalItems = resTotalEntries.data.data;
        }
        this.entriesLoaded = true;
      } catch (err) {
        console.log(err);
      }
    },
    // async reloadEntries (clientId) {
    //   this.entriesLoaded = false
    //   if (
    //     clientId === undefined ||
    //     clientId === null ||
    //     clientId === ''
    //   ) {
    //     return
    //   }
    //   try {
    //     let res = await brogglBack.get('/entries/paginateClient', {params: {page: this.currentPage, clientId: clientId}, headers: {Authorization: 'Bearer ' + window.$cookies.get('jwt').data}})
    //     const sortedKeys = Object.keys(res.data.data).sort((a, b) => {
    //       const dateA = new Date(a);
    //       const dateB = new Date(b);
    //       return dateB - dateA;
    //     });

    //     sortedResult= {}
    //     sortedKeys.forEach((key) => {
    //       sortedResult[key] = res.data.data[key];
    //     });

    //     this.entries = sortedResult;
    //     let resTotalEntries = await brogglBack.get('/entries/NumberOfEntriesForClient', {params: {clientId: clientId}, headers: {Authorization: 'Bearer ' + window.$cookies.get('jwt').data}})
    //     this.totalItems = resTotalEntries.data.data
    //     this.entriesLoaded = true

    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    async fetchRecap() {
      const productStore = useProductStore();
      let clientId = null;
      if (router.currentRoute.value.params.id !== undefined) {
        clientId = router.currentRoute.value.params.id;
      } else if (
        productStore.parameters.client !== null ||
        productStore.parameters.client !== undefined
      ) {
        clientId = productStore.parameters.client;
      }
      try {
        const res = await brogglBack.get("entries-details-v2/", {
          params: { client_id: clientId },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        this.barChartData.datasets[0].data = Object.values(
          res.data.entries_by_project,
        );
        this.barChartData.labels = Object.keys(res.data.entries_by_project);
        this.chartData.labels = Object.keys(res.data.entries_by_month);
        this.chartData.datasets[0].data = Object.values(
          res.data.entries_by_month,
        );
        this.loaded = true;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchRecapV2(clientId) {
      this.entriesLoaded = false;
      try {
        const res = await brogglBack.get("entries-details-v2/", {
          params: { client_id: clientId },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        this.barChartData.datasets[0].data = Object.values(
          res.data.entries_by_project,
        );
        this.barChartData.labels = Object.keys(res.data.entries_by_project);
        this.chartData.labels = Object.keys(res.data.entries_by_month);
        this.chartData.datasets[0].data = Object.values(
          res.data.entries_by_month,
        );
        this.loaded = true;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchClientDashboard() {
      const productStore = useProductStore();
      const clientStore = useClientStore();
      let clientId = null;
      if (router.currentRoute.value.params.id !== undefined) {
        clientId = router.currentRoute.value.params.id;
      } else if (
        productStore.parameters.client !== null ||
        productStore.parameters.client !== undefined
      ) {
        clientId = productStore.parameters.client;
      }

      try {
        const res = await brogglBack.get(
          "/client/dashboard/" + clientId + "/" + clientStore.currContractId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        if (res.data.data.Support !== null) {
          if (
            Object.hasOwn(
              res.data.data.Support,
              "TotalDays",
            ) &&
            Object.hasOwn(
              res.data.data.Support,
              "AvgDays",
            )
          ) {
            this.basicSupportHours = res.data.data.Support.TotalDays;
            this.basicSupportAverage =
              res.data.data.Support.AvgDays;
          }
        }
        if (res.data.data.BasicTechnicalSupport.hours !== null) {
          if (
            Object.hasOwn(
              res.data.data.BasicTechnicalSupport,
              "TotalDays",
            ) &&
            Object.hasOwn(
              res.data.data.BasicTechnicalSupport,
              "AvgDays",
            )
          ) {
            this.BasicTechnicalSupportSinceContract =
              res.data.data.BasicTechnicalSupport.TotalDays;
            this.BasicTechnicalSupportMonthly =
              res.data.data.BasicTechnicalSupport.AvgDays;
          }
        }
        if (res.data.data.AskTSE !== null) {
          if (
            Object.hasOwn(
              res.data.data.AskTSE,
              "TotalDays",
            ) &&
            Object.hasOwn(
              res.data.data.AskTSE,
              "AvgDays",
            )
          ) {
            this.askTSEHoursSinceContract = res.data.data.AskTSE.TotalDays;
            this.askTSEHoursMeanMonthly =
              res.data.data.AskTSE.AvgDays;
          }
        }
        if (res.data.data.EntitySupport !== null) {
          this.timeCounterByEntity = res.data.data.EntitySupport;
        }
        if (res.data.data.CustomerSuccess !== null) {
          if (
            Object.hasOwn(
              res.data.data.CustomerSuccess,
              "TotalDays",
            ) &&
            Object.hasOwn(
              res.data.data.CustomerSuccess,
              "AvgDays",
            )
          ) {
            this.customerSuccesHours = res.data.data.CustomerSuccess.TotalDays;
            this.customerSuccessAverage =
              res.data.data.CustomerSuccess.AvgDays;
          }
        }
        if (res.data.data.ProfessionalServices !== null) {
          if (
            Object.hasOwn(
              res.data.data.ProfessionalServices,
              "TotalDays",
            ) &&
            Object.hasOwn(
              res.data.data.ProfessionalServices,
              "AvgDays",
            )
          ) {
            this.professionalServicesHours =
              res.data.data.ProfessionalServices.TotalDays;
            this.professionalServicesAverage =
              res.data.data.ProfessionalServices.AvgDays;
          }
        }
        if (res.data.data.Onboarding !== null) {
          if (
            Object.hasOwn(
              res.data.data.Onboarding,
              "TotalDays",
            ) &&
            Object.hasOwn(
              res.data.data.Onboarding,
              "AvgDays",
            )
          ) {
            this.onboardingHours = res.data.data.Onboarding.TotalDays;
            this.onboardingAverage = res.data.data.Onboarding.AvgDays;
          }
        }
        if (res.data.data.ProductClient !== null) {
          if (
            Object.hasOwn(
              res.data.data.ProductClient,
              "totalContracted",
            ) &&
            Object.hasOwn(
              res.data.data.ProductClient,
              "totalUsed",
            ) &&
            Object.hasOwn(
              res.data.data.ProductClient,
              "totalTimeSpent",
            ) &&
            Object.hasOwn(
              res.data.data.ProductClient,
              "averageDays",
            )
          ) {
            this.totalProducts = res.data.data.ProductClient.totalContracted;
            this.totalUsageProducts = res.data.data.ProductClient.totalUsed;
            this.totalTimeSpentOnCampaigns =
              res.data.data.ProductClient.totalTimeSpent;
            this.averageTimeSpentOnCampaigns =
              res.data.data.ProductClient.averageDays;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchTimeCounterByEntity() {
      const productStore = useProductStore();
      let clientId = null;
      if (router.currentRoute.value.params.id !== undefined) {
        clientId = router.currentRoute.value.params.id;
      } else if (
        productStore.parameters.client !== null ||
        productStore.parameters.client !== undefined
      ) {
        clientId = productStore.parameters.client;
      }
      try {
        const res = await brogglBack.get("entity-support-hours", {
          params: { client: clientId },
          headers: { Authorization: window.$cookies.get("jwt") },
        });
        if (res.data) {
          let data = res.data;
          const index = data.findIndex((item) => item.name === "Blank");
          if (!(index === -1)) {
            const indexData = data.find((item) => item.name === "Blank");
            data.splice(index, 1);
            data.sort(function (a, b) {
              return b.time - a.time;
            });
            data.splice(0, 0, indexData);
          } else {
            data.sort(function (a, b) {
              return b.time - a.time;
            });
          }
          let result = [];
          data.forEach(function (item) {
            result.push(
              item.name +
                " : " +
                Math.round((item.time / 8) * 10) / 10 +
                " day(s)",
            );
          });
          this.timeCounterByEntity = result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async monthlyUseUpdate(product) {
      try {
        const res = await brogglBack.get("monthly-use", {
          params: { productId: product.ID },
          headers: { Authorization: window.$cookies.get("jwt") },
        });
        if (res.data !== null) {
          product.monthlyUse = res.data;
          product.productFullName =
            product.product_name +
            " - (" +
            (product.total - product.monthly_use) +
            ")";
        } else if (res.status === 401) {
          window.$cookies.set("jwt", "");
        }
      } catch (err) {
        console.log(err);
      }
    },
    resetEntriesHistory() {
      const productStore = useProductStore();
      this.currentPage = 1;
      this.nextPage = 1;
      productStore.entries = {};
    },
    async fetchOfferedCampaigns() {
      const clientStore = useClientStore();
      let clientId = clientStore.getClientId();
      let oppId = clientStore.currContractId;
      try {
        const res = await brogglBack.get(
          "/test/offered-campaigns/" + clientId + "/" + oppId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        if (res.data !== null) {
          this.offeredCampaigns = res.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchOfferedAnalysis() {
      const clientStore = useClientStore();
      let clientId = clientStore.getClientId();
      let oppId = clientStore.currContractId;
      try {
        const res = await brogglBack.get(
          "/test/offered-analyses/" + clientId + "/" + oppId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        if (res.data !== null) {
          this.offeredAnalysis = res.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async updateOfferedCampaigns() {
      let req = [];
      this.offeredCampaignsErrorMsg = "";
      const clientStore = useClientStore();
      let clientId = clientStore.getClientId();
      this.offeredCampaigns.forEach((campaign) => {
        if (
          campaign.ProductId !== null &&
          campaign.ProductId > 0 &&
          campaign.ManDaysUsed !== null &&
          campaign.ManDaysUsed > 0
        ) {
          req.push({
            campaignId: campaign.ID,
            productId: campaign.ProductId,
            productUse: campaign.ManDaysUsed,
          });
        } else if (
          (campaign.ProductId === null &&
            campaign.ProductId === 0 &&
            campaign.ManDaysUsed !== null) ||
          (campaign.ProductId !== null &&
            campaign.ManDaysUsed === 0 &&
            campaign.ManDaysUsed === null)
        ) {
          this.offeredCampaignsErrorMsg =
            "Please select a product and a product use";
          this.offeredAnalysisErrorMsg =
            "Please select a product and a product use";
        }
      });
      if (req.length > 0) {
        try {
          const res = await brogglBack.put("/test/OfferedCampaigns", req, {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          });
          this.offeredCampaigns = [];
          req = [];
          this.fetchOfferedCampaigns();
        } catch (err) {
          console.log(err);
        }
      }
    },
    async updateOfferedAnalysis() {
      let req = [];
      this.offeredCampaignsErrorMsg = "";
      const clientStore = useClientStore();
      let clientId = clientStore.getClientId();
      this.offeredAnalysis.forEach((campaign) => {
        if (campaign.ProductId !== null && campaign.ManDaysUsed !== null) {
          req.push({
            campaignId: campaign.ID,
            productId: campaign.ProductId,
            productUse: campaign.ManDaysUsed,
          });
        } else if (
          (campaign.productId === null && campaign.productUse !== null) ||
          (campaign.productId !== null && campaign.productUse === null)
        ) {
          this.offeredCampaignsErrorMsg =
            "Please select a product and a product use";
          this.offeredAnalysisErrorMsg =
            "Please select a product and a product use";
        }
      });
      if (req.length > 0) {
        try {
          const res = await brogglBack.put("/test/OfferedAnalyses", req, {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          });
          this.offeredAnalysis = [];
          this.fetchOfferedAnalysis();
        } catch (err) {
          console.log(err);
        }
      }
    },
    deleteKeyInEntries(key) {
      if (this.entries[key].length <= 1) {
        delete this.entries[key];
      }
    },
    async fetchRawEntriesData(dateFormat) {
      try {
        const res = await brogglBack.get("/entries/raw/file", {
          params: { dateFormat: dateFormat },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        let filename = "";
        if (dateFormat.includes(";")) {
          const firstYear = dateFormat.split(";")[0].split("-")[0];
          const secondYear = dateFormat.split(";")[1].split("-")[0];
          filename =
            "entries_raw_export_FY_" +
            firstYear +
            "-" +
            secondYear +
            "_" +
            new Date().toISOString().split("T")[0] +
            ".csv";
        } else {
          filename =
            "entries_raw_export_All_Time_" +
            new Date().toISOString().split("T")[0] +
            ".csv";
        }
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.log(err);
      }
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEntriesStore, import.meta.hot));
}
